import React, { Component } from "react";
import "./Header.scss"
import { push } from "../Services/Analytics";

class Header extends Component {
  constructor() {
    super()
    this.toggleMenu = this.toggleMenu.bind(this);
    this.state = {
      isMenuClicked: false
    }
  }
  toggleMenu() {
    this.props.menuClicked(!this.state.isMenuClicked);
    if (this.state.isMenuClicked === false) {
      push("Header", "");
    }
    this.setState({
      isMenuClicked: !this.state.isMenuClicked
    })
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      isMenuClicked: nextProps.toggleMenu
    })
  }
  render() {
    return (
      <header>
        <div id="header" className={`${(this.props.currentScreen == 4 ? " active" : "")} ${(this.props.currentScreen == 5 ? "pbwhite" : "")}`}>
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <a href="https://ynet.co.il/" title="" target="_blank"><div className="logo"></div></a>
              </div>
              <div className="utils"></div>
              <div className="sponser">
                <a href="https://fb.me/poweredb" title="" target="_blank"><div className="pblogo"></div></a>
                <a href="" title="" target="_blank"><div className="sponslogo"></div></a>
              </div>
            </div>
            <div className={`menu ${this.state.isMenuClicked ? " active" : ""}`} onClick={this.toggleMenu}>
              <div className="lines">
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtualHeader"></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx